export const comments_3257648 = {"data":{"data":[],"links":{}}}